import script from "./ShisetsuTaikenDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ShisetsuTaikenDetail.vue?vue&type=script&setup=true&lang=js"

import "./ShisetsuTaikenDetail.vue?vue&type=style&index=0&id=55d020ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d020ab"]])

export default __exports__